type ChatState = {
  loading: boolean;
  mode: 'chats' | 'chat';
  collapsed: boolean;
  activeChatId: number | null;
} & initialFields;

type initialFields = {
  chat_history: Record<string, unknown>;
  friends: any[];
  token: string;
  user: any;
};

type ChatMessage = {
  chat_id: number;
};

const initialFields = {
  chat_history: {},
  friends: [],
  token: '',
  user: {},
};

const getInitialState = () => ({
  loading: true,
  mode: 'chats', // chats, chat
  collapsed: true,
  activeChatId: null,
  ...initialFields,
});

export default {
  state: getInitialState,
  mutations: {
    updateFriend(state: ChatState, updatedFriend: { id: number }) {
      state.friends = state.friends.map(f => {
        if (f.id === updatedFriend.id) {
          return { ...f, ...updatedFriend };
        }
        return f;
      });
    },
    removeFriendById(state: ChatState, friendId: number) {
      state.friends = state.friends.filter(f => f.id !== friendId);
    },
    setState(state: ChatState, newState: Partial<ChatState>) {
      Object.keys(initialFields).forEach(k => {
        // @ts-expect-error
        state[k] = newState[k];
      });
    },
    toggleLoading(state: ChatState, loading: boolean) {
      state.loading = loading;
    },
    addMessage(state: ChatState, newMessage: ChatMessage) {
      const chatId = newMessage.chat_id;
      const chatHistory = state.chat_history[chatId] || [];

      state.chat_history = {
        ...state.chat_history,
        // @ts-expect-error
        [chatId]: [...chatHistory, newMessage],
      };
    },
    markChatHistoryAsRead(state: ChatState, chatId: number) {
      // @ts-expect-error
      const chat = (state.chat_history[chatId] || []).map(el => {
        return { ...el, read: true };
      });

      state.chat_history = { ...state.chat_history, [chatId]: chat };
    },
    toggleCollapsed(state: ChatState) {
      state.collapsed = !state.collapsed;
    },
    setMode(state: ChatState, mode: ChatState['mode']) {
      state.mode = mode;
    },
    openChat(state: ChatState, chatId: number) {
      state.activeChatId = chatId;
    },
    addFriend(state: ChatState, newFriend: unknown) {
      state.friends = [...state.friends, newFriend];
    },
    setActiveChat(state: ChatState, chatId: number) {
      state.activeChatId = chatId;
    },
    resetState(state: ChatState) {
      Object.assign(state, getInitialState());
    },
  },
};
